
import { useEffect, useState } from "react";
import { useGetEnumsQuery } from "../../../../app/globalApi";
import { useFindUserSettingsByGroupNameQuery } from "../../../../components/common/userSetting/userSettingsApi";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import IconButton from "../../../../components/common/form/IconButton";
import { FaPlus } from "react-icons/fa6";
import { DataTable } from "../../../../components/common/datatable/DataTable";
import { useLazyExportAutoHoaDataQuery, useSearchAutoHoaApiQuery } from "../autoHoa";
import { useNavigate } from "react-router-dom";
import {
    SearchSelectWithEnum,
    SearchSelectWithList
} from "../../../../components/common/datatable/filter/SearchSelectWrapper";
import { createClickableLink } from "../../../../components/common/datatable/DataTableUtils";
import { getEnumDisplayNameByConstant } from "../../../../helpers/utils/EnumUtils";
import { useGetAllStatesQuery } from "../../../data/states/statesApi";
import { useLazyGetAllCountyByStateAbbrQuery } from "../../../data/counties/countiesApi";
import { useLazyGetMetroAreaByStateAbbrQuery } from "../../../data/metroAreas/metroAreasApi";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";
import { getStateValueFromParam } from "../../../../helpers/utils/Utils";

const AutoHoa = () => {

    const { data: userSetting } = useFindUserSettingsByGroupNameQuery("Association");
    const { data: enums } = useGetEnumsQuery("");
    const [triggerExportAutoHoaDataQuery] = useLazyExportAutoHoaDataQuery();
    const stateDataApi = useGetAllStatesQuery("");
    const navigate = useNavigate();
    const [getAllCountyByStateAbbrApi, getAllCountyByStateAbbrApiResponse] = useLazyGetAllCountyByStateAbbrQuery()
    const [getAllMsaDataApi, getAllMsaDataApiResponse] = useLazyGetMetroAreaByStateAbbrQuery();
    const state = getStateValueFromParam(window);

    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Auto HOA", url: "" }]
    )
    useEffect(() => {
        document.title = 'Auto HOA';

    }, []);



    useEffect(() => {
        getAllCountyByStateAbbrApi(state);
        getAllMsaDataApi(state)
    }, [state]);


    const columns: DataTableColumn[] = [

        {
            label: "State", accessor: "county.state.stateName", canSort: false, visibility: { hasShowSetting: false },
            filterOptions: [{
                dependentColumns: ["County", "Metro Area"],
                filterComponent: SearchSelectWithList(stateDataApi?.data, "stateName", "stateAbbreviation", "Select State...", false, "state"),
                overrideFilterLabel: "State",
                overrideFilterAccessor: "state"
            }],
            cell: (props: any) => {
                if (hasPermission(["AUTOHOA-R"])) {
                    let path = "/auto-hoa/" + props.row.original.id;
                    return createClickableLink(path, props.row.original?.county !== null ? props.row.original?.county?.state?.stateName : props.row.original?.msa?.state?.stateName, userSetting);
                } else {
                    return <>
                        <span>{props.row.original?.county !== null ? props.row.original?.county?.state?.stateName : props.row.original?.msa?.state?.stateName}</span>
                    </>
                }
            },
        },

        {
            label: "County", accessor: "county.countyName", visibility: { hasShowSetting: false },
            filterOptions: [{
                filterComponent: SearchSelectWithList(getAllCountyByStateAbbrApiResponse?.data, "countyName", "id", "Select County...", false, "county"),
                overrideFilterAccessor: "county",
                onDependencyUpdated: (value: string) => {
                    getAllCountyByStateAbbrApi(value);
                },
            }]
        },

        {
            label: "Metro Area", accessor: "msa.name", visibility: { hasShowSetting: false },
            filterOptions: [{
                filterComponent: SearchSelectWithList(getAllMsaDataApiResponse?.data, "name", "id", "Select Metro Area...", false, "msa"),
                overrideFilterAccessor: "msa",
                onDependencyUpdated: (value: string) => {
                    getAllMsaDataApi(value);
                },
            }],
        },

        {
            label: "Product Type", accessor: "productType",
            cell: (props: any) => getEnumDisplayNameByConstant(enums?.["ProductType"], props.value),
            filterOptions: [{
                filterComponent: SearchSelectWithEnum(enums?.["ProductType"] && enums?.["ProductType"].filter((p: { value: string | string[]; }) => p.value.includes("HOA")), "Select Product Type...", false, "productType"),
                overrideFilterLabel: "Product Type",
            }]
        },

        {
            label: "Tenant", accessor: "tenant", visibility: { disallowedCustomerLevels: ["CUSTOMER", "TENANT"] },
            cell: (props: any) => {
                return <>
                    <span>{props.value}</span>
                </>
            },
        }


    ]

    return (
        <div className="px-4 py-2">
            <div className="flex justify-between mb-2.5">
                <Breadcrumb crumbs={crumbs} />
            </div>

            <DataTable
                columns={columns}
                actions={{
                    fetchAction: useSearchAutoHoaApiQuery,
                    exportAction: triggerExportAutoHoaDataQuery
                }}
                buttonOptions={{
                    addButton:
                    {
                        button: <IconButton
                            icon={<FaPlus />}
                            hasBackground={true}
                            onClick={() => {
                                navigate("/auto-hoa/create")
                            }}
                            title={"Create Auto HOA"}
                        />,
                        permissions: ["ASSOC-C"]
                    },
                }}
                userSettingGroup={"Auto-Hoa"}
                defaultSortOptions={{
                    accessor: "creationDate",
                    direction: "asc"
                }}
                defaultFilter={{
                    state: "TX"
                }}
                basePermission={"AUTOHOA"}
            />
        </div>
    );
}
export default AutoHoa;